/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateDocumentTemplateFastPreviewConfigurationDTO { 
    enableForAll?: boolean;
    feature?: UpdateDocumentTemplateFastPreviewConfigurationDTO.FeatureEnum;
    selectedSubtypes?: Array<number>;
}
export namespace UpdateDocumentTemplateFastPreviewConfigurationDTO {
    export type FeatureEnum = 0 | 1;
    export const FeatureEnum = {
        NUMBER_0: 0 as FeatureEnum,
        NUMBER_1: 1 as FeatureEnum
    };
}